import { Estimation } from '@aviv-estimation-funnel/estimation-data-models/models';
import { httpService } from '@mfe-services/http';

const WLEF_API_URL = process.env['NX_WLEF_API_URL'];
const WLEF_API_KEY = process.env['NX_WLEF_API_KEY'];

export const getEstimationByToken = async (
    tokenJWT: string,
    portal: string,
): Promise<Estimation> => {
    const { data } = await httpService.get<Estimation>(
        `${WLEF_API_URL}/v1/estimations/token/${tokenJWT}?portal=${portal}`,
        {
            headers: {
                'x-api-key': WLEF_API_KEY,
            },
        },
    );
    return data;
};
